export default "<router-outlet></router-outlet>\n<ngx-loading [show]=\"spinnerService.visibility | async\"></ngx-loading>\n\n\n";